import React from 'react';
import FirstLogin from '../components/auth/FirstLogin';

const FirstLoginPage = () => {
    return <FirstLogin />;
};

export default FirstLoginPage;